<div
    class="gap-2"
    [ngClass]="[layoutClass, maxHeightClass || '', maxHeightClass ? 'overflow-auto pr-1' : 'overflow-visible']">
    <button
        *ngFor="let option of options; trackBy: trackByValue"
        type="button"
        class="group flex min-w-0 items-center justify-between border text-left transition focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-300 disabled:cursor-not-allowed disabled:opacity-60"
        [ngClass]="[
            pillClass,
            columns === 'auto' ? 'w-auto' : 'w-full',
            isSelected(option)
                ? 'border-sky-200 bg-sky-50 text-sky-700 hover:bg-sky-50'
                : 'border-slate-200 bg-white/60 text-slate-700 hover:border-sky-200 hover:bg-white'
        ]"
        [disabled]="isOptionDisabled(option)"
        [attr.aria-pressed]="isSelected(option)"
        (click)="toggle(option)">
        <span class="flex min-w-0 items-center gap-2">
            <span
                class="shrink-0 rounded-full"
                [ngClass]="dotClass"
                [style.background]="option.color || 'rgba(148, 163, 184, 0.72)'"></span>
            <span class="min-w-0">
                <strong class="block truncate font-semibold" [ngClass]="labelClass">{{ option.label }}</strong>
                <small *ngIf="option.description" class="block truncate text-slate-500" [ngClass]="descriptionClass">
                    {{ option.description }}
                </small>
            </span>
        </span>
        <fa-icon
            class="shrink-0"
            [ngClass]="iconClass"
            [icon]="isSelected(option) ? selectedIcon : unselectedIcon"></fa-icon>
    </button>

    <span *ngIf="!options?.length" class="text-xs text-slate-400">
        {{ emptyText || 'No options' }}
    </span>
</div>
